import { render, staticRenderFns } from "./dealerHeader.vue?vue&type=template&id=07a1386f&"
import script from "./dealerHeader.vue?vue&type=script&lang=js&"
export * from "./dealerHeader.vue?vue&type=script&lang=js&"
import style0 from "./dealerHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports